import { toCents } from '@/utils/helpers';

export default {
  props: {
    predictionType: Number,
    tradeType: Number,
    quantity: Number,
    price: Number,
  },
  computed: {
    typeToString() {
      switch (this.tradeType) {
        case 0: // Buy No
        case 1: // Buy Yes
          return 'Bought';
        case 2: // Sell No
        case 3: // Sell Yes
          return 'Sold';
        default:
          return 'Closed'; // 4 - Closed
      }
    },
    closedText() {
      if (this.tradeType === 4) {
        const price = toCents(this.price);
        const yesNo = this.predictionType === 0 ?
          `<span class="sold-bought-at__quantity sold-bought-at--negative">${this.quantity}</span>` :
          `<span class="sold-bought-at__quantity">${this.quantity}</span>`;

        if (price === 0) {
          return `${yesNo} pays $0`;
        }
        const pays = price === 100 ? '$1' : this.priceToString;
        return `${yesNo} pays ${pays}`;
      }
      return null;
    },
    priceToString() {
      return `${toCents(this.price)}¢`;
    },
    negativeModifier() {
      return {
        'sold-bought-at--negative': (this.tradeType === 0 || this.tradeType === 2),
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/contracts-history/sold-bought-at/sold-bought-at.js